module.exports = __webpack_public_path__ + "static/media/logInIcon.e05d2cb0.svg";